import { useNavigate } from 'react-router-dom';
import { authService } from '../api';
import { useApi } from './useApi';
import { useAuth } from './useAuth';
import { getRoleRedirectPath } from '../utils/userUtils';

interface LoginFormData {
  email: string;
  password: string;
}

export const useLogin = () => {
  const navigate = useNavigate();
  const { updateAuth } = useAuth();

  const { loading, error, execute } = useApi({
    successMessage: 'Login successful!',
    showSuccessToast: true,
    showErrorToast: true,
    onSuccess: (response: any) => {
      const token = response?.access_token || response?.token;
      const user = response?.user;

      if (token && user) {
        updateAuth(token, user);
      }

      setTimeout(() => {
        const redirectPath = getRoleRedirectPath(user?.role);
        navigate(redirectPath);
      }, 1000);
    },
  });

  const login = async (formData: LoginFormData) => {
    return execute(() => authService.login(formData));
  };

  return {
    login,
    loading,
    error,
  };
};
